import React, { Fragment } from 'react';
import I18n from '../../config/locales/e_i18n';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import queryString from 'query-string';
import { makeStyles } from '@material-ui/core/styles';
import { Box, AppBar, Avatar, Toolbar } from '@material-ui/core';
import HeaderImage from '../../components/Header/Icons/enlighten-logo.png';
import { setMobileView } from './actions';
import { Footer } from '../../components/common/Footer';
import analytics from '../../utils/analytics';
import { getValue, setValue, removeKey } from '../../utils/localStorage';
import getMoment from '../../components/common/moment';
import { setLocale } from '../AccountDetails/actions';
import { get } from '../../utils/lodash';
import { forwardTo, setToken, decodeToken, getToken, constructQueryString } from '../../utils/helper';

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5)
  },
  body: {
    marginTop: theme.spacing(5.5)
  },
  headerRoot: {
    display: 'flex',
    background: theme.palette.primary.main,
    flexDirection: 'row',
    boxShadow: 'none',
    zIndex: 11,
    position: 'fixed',
    padding: theme.spacing(1, 0)
  },
  headerToolbar: {
    margin: theme.spacing(0, 4),
    padding: 0,
    minHeight: 0
  },
  large: {
    width: theme.spacing(15),
    height: 'auto'
  }
}));

const Layout = ({ children, isMobileView, isAdmin, accountDetail, ...rest }) => {
  const classes = useStyles();
  return (
    <Fragment>
      <AppBar position="static" color="secondary" className={classes.headerRoot}>
        <Toolbar className={classes.headerToolbar}>
          <Avatar variant="square" alt="enphase logo" src={HeaderImage} className={classes.large} />
        </Toolbar>
      </AppBar>
      <Box className={classes.body}>
        <Box className={classes.root}>{children}</Box>
      </Box>
      <Footer isFromLogin />
    </Fragment>
  );
};

class LoginLayout extends React.Component {
  constructor(props) {
    super(props);
    const { search, pathname } = props.location;
    const { locale, token, ...remainingQuery } = queryString.parse(search);
    const tokenValue = token || getToken() || props.enlightenManagerToken;
    const { company_id } = decodeToken(tokenValue);
    const companyIdFromParam = get(props, 'computedMatch.params.companyId');
    const companyId = companyIdFromParam ? companyIdFromParam : company_id;
    let localeValue = locale;
    if (localeValue) {
      removeKey('locale_id');
    } else {
      localeValue = getValue('locale_id') || localeValue;
    }
    setValue('locale_id', localeValue || 'en');
    const isTokenEmpty = !tokenValue || tokenValue === '' || parseInt(tokenValue, 10) === -1;
    this.analytics = new analytics();
    if (!isTokenEmpty && pathname) {
      setToken(tokenValue);
      const queryString = constructQueryString(remainingQuery);
      forwardTo(`/manager/dashboard${queryString}`);
    } else {
      const queryString = constructQueryString(remainingQuery);
      const forwardPathname = `${pathname}${queryString}`;
      forwardTo(forwardPathname);
    }
    this.analytics.setUserId('', '');
  }

  UNSAFE_componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    const isMobileView = window.innerWidth <= 1200;
    this.props.setMobileView(isMobileView);
  };

  componentDidMount = () => {
    this.handleWindowSizeChange();
  };

  componentDidUpdate() {
    if (this.props.locale !== getValue('locale_id')) {
      const locale = getValue('locale_id') || 'en';
      this.props.setLocale({ locale });
      I18n.defaultLocale = 'en';
      I18n.locale = locale;
      I18n.fallbacks = true;
      getMoment(locale);
    }
  }

  render() {
    const { component: Component, isMobileView, isAdmin, accountDetail, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={matchProps => (
          <Layout isMobileView={isMobileView} isAdmin={isAdmin} accountDetail={accountDetail}>
            <Component {...matchProps} />
          </Layout>
        )}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setMobileView: isMobileView => dispatch(setMobileView(isMobileView)),
  setLocale: payload => dispatch(setLocale(payload))
});

const mapStateToProps = state => ({
  isMobileView: state.appReducer.isMobileView,
  isAdmin: state.appReducer.isAdmin,
  locale: state.accountReducer.locale,
  enlightenManagerToken: state.appReducer.enlightenManagerToken
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginLayout);
